import type { UseQueryOptions } from '@core/types'
import type { components } from '@core/types/clients/strapi'
import { useCoreConfig, useQuery, useStrapi } from '#imports'

export type FaqCollection = components['schemas']['FaqCollection']
export type FaqSections = FaqCollection['faqSections']
export type FaqSection = NonNullable<FaqSections>[number]

export const useStrapiFaq = () => {
    const { site } = useCoreConfig()
    const strapi = useStrapi()

    function getFaqCollections(
        options: Pick<UseQueryOptions<any>, 'enabled' | 'lazy' | 'server'> = {}
    ) {
        const { enabled = true, lazy = false, server = false } = options

        const query = useQuery <FaqCollection[]>(async () => {
            const { data } = await strapi.GET('/faq-collections', {
                params: {
                    query: {
                        brand: site.brand
                    }
                },
            })

            return data as FaqCollection[]
        }, {
            key: 'strapi:faq-collections',
            lazy,
            server,
            enabled,
        })

        return query
    }

    return {
        getFaqCollections
    }
}
